import { render } from "./FolderModal.vue?vue&type=template&id=6e21c5eb&ts=true"
import script from "./FolderModal.vue?vue&type=script&lang=ts"
export * from "./FolderModal.vue?vue&type=script&lang=ts"

import exportComponent from "/home/runner/work/webeye-pro-frontend/webeye-pro-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__